// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jv_a bhv_a bhv_j bhv_q bhv_rp bhv_rq bhv_w"};